import { render, staticRenderFns } from "./addBusinessUnitDialog.vue?vue&type=template&id=4045e147&scoped=true"
import script from "./addBusinessUnitDialog.vue?vue&type=script&lang=js"
export * from "./addBusinessUnitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045e147",
  null
  
)

export default component.exports